import { PredictionLabelType } from '@modules/feedback/types';
import { FormatQuoteRounded, NumbersRounded } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { getLabelTypeFromPredictionType } from './getLabelTypeFromPredictionType';

interface GetFeedbackLabelIconProps extends SvgIconProps {
  label: FeedbackLabel;
  shouldShowPrimaryColor?: boolean;
}

export const getFeedbackLabelIcon = ({
  label,
  fontSize = 'small',
  shouldShowPrimaryColor = true,
  ...iconProps
}: GetFeedbackLabelIconProps) => {
  switch (label.type) {
    case getLabelTypeFromPredictionType(PredictionLabelType.Entity):
      return (
        <NumbersRounded
          fontSize={fontSize}
          sx={{
            color: shouldShowPrimaryColor ? 'primary.main' : 'text.secondary',
          }}
          {...iconProps}
        />
      );
    case getLabelTypeFromPredictionType(PredictionLabelType.Reason):
      return (
        <FormatQuoteRounded
          fontSize={fontSize}
          sx={{
            color: shouldShowPrimaryColor ? 'primary.main' : 'text.secondary',
          }}
          {...iconProps}
        />
      );
    default:
      return null;
  }
};
